import { render, staticRenderFns } from "./pluginoverview.vue?vue&type=template&id=325ab2f5&"
import script from "./pluginoverview.vue?vue&type=script&lang=js&"
export * from "./pluginoverview.vue?vue&type=script&lang=js&"
import style0 from "./pluginoverview.vue?vue&type=style&index=0&id=325ab2f5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports